<template>
  <transition-group :name="name">
    <slot/>
  </transition-group>
</template>
<script>
export default {
  name: 'CssGroup',
  props: ['name']
}
</script>



// WEBPACK FOOTER //
// CssGroup.vue?99f9d274